module.exports = __webpack_public_path__ + "img/technology7.5cf5975f.png";